(function() {
  'use strict';

  // ============================================================
  // 1. SCROLL REVEAL
  // ============================================================
  var prefersReduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var revealEls = document.querySelectorAll('.reveal');

  if (prefersReduced || !('IntersectionObserver' in window)) {

    revealEls.forEach(function(el) {
      el.classList.add('in');
    });

  } else {

    var io = new IntersectionObserver(function(entries) {

      entries.forEach(function(entry) {

        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }

      });

    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    });

    revealEls.forEach(function(el) {
      io.observe(el);
    });

  }

  // ============================================================
  // 2. STICKY BAR
  // ============================================================
  var stickyBar = document.getElementById('stickyBar');
  var footer = document.querySelector('.footer');
  var finalCta = document.getElementById('kaufen');

  function updateStickyBar() {

    if (!stickyBar) return;

    var scrolled =
      window.scrollY ||
      window.pageYOffset;

    var docHeight =
      document.documentElement.scrollHeight -
      window.innerHeight;

    var scrollPct =
      docHeight > 0
        ? (scrolled / docHeight)
        : 0;

    var hideZone = false;

    if (finalCta) {

      var rect = finalCta.getBoundingClientRect();

      if (
        rect.top < window.innerHeight &&
        rect.bottom > 0
      ) {
        hideZone = true;
      }

    }

    if (footer) {

      var footerRect = footer.getBoundingClientRect();

      if (footerRect.top < window.innerHeight) {
        hideZone = true;
      }

    }

    if (scrollPct > 0.18 && !hideZone) {
      stickyBar.classList.add('visible');
    } else {
      stickyBar.classList.remove('visible');
    }

  }

  var stickyTicking = false;

  window.addEventListener('scroll', function() {

    if (!stickyTicking) {

      requestAnimationFrame(function() {

        updateStickyBar();
        stickyTicking = false;

      });

      stickyTicking = true;

    }

  }, {
    passive: true
  });

  updateStickyBar();

  // ============================================================
  // 3. FAQ ACCORDION
  // ============================================================
  var faqItems = document.querySelectorAll('.faq-item');

  faqItems.forEach(function(item) {

    item.addEventListener('toggle', function() {

      if (item.open) {

        faqItems.forEach(function(other) {

          if (
            other !== item &&
            other.open
          ) {
            other.open = false;
          }

        });

      }

    });

  });

  // ============================================================
  // 4. SMOOTH SCROLL
  // ============================================================
  document
    .querySelectorAll('a[href^="#"]')
    .forEach(function(link) {

      link.addEventListener('click', function(e) {

        var href = link.getAttribute('href');

        if (href.length < 2) return;

        var target =
          document.querySelector(href);

        if (!target) return;

        e.preventDefault();

        var top =
          target.getBoundingClientRect().top +
          window.scrollY -
          70;

        window.scrollTo({
          top: top,
          behavior: 'smooth'
        });

      });

    });

})();